<template>
  <div>
    <Header :pageIndex="1"/>
    <CBanner imgUrl="/static/banner6.png" title1="关于我们" title-en="About Us" titleEn="About Us" title2="提供以品牌电子商务为核心的一站式商业解决方案"/>
    <CTitle title="/static/about-us.png" desc="About Us"/>
    <CUs/>
    <CToTop/>
  </div>
</template>

<script>
  import CTitle from "@/components/CTitle";
  import CUs from "@/components/CUs";
  import CBanner from "@/components/CBanner";
  import CToTop from "@/components/CToTop";
  import Header from "../Header";

  export default {
    name: "AboutUs",
    components: {Header, CToTop, CBanner, CUs, CTitle},
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contains/AboutUs.vue